module.exports = __webpack_public_path__ + "img/3.a1866e22.jpg";